module.exports = __webpack_public_path__ + "static/img/guide.83548b73.png";